const ALL_VALID_FILTERS = [
  "filter.v.price.gte",
  "filter.v.price.lte",
  "filter.v.product_type",
  "filter.v.availability",
];

const initCollectionFilters = () => {
  const collectionPage = document.querySelector(".MainCollection");

  if (!collectionPage) return;

  const container = collectionPage.querySelector(
    ".MainCollection--grid-container"
  );
  const filtersTrigger = collectionPage.querySelector(
    ".MainCollection--filter-btn"
  );

  /*
  filtersTrigger.addEventListener("click", () => {
    filtersTrigger.classList.toggle("Open");
    container.classList.toggle("FiltersOpen");
  });
  */

  const sortSelect = collectionPage.querySelector(".CollectionSort select");

  // get select value from URL params if exists
  const urlParams = new URLSearchParams(window.location.search);
  const sort = urlParams.get("sort_by");
  if (sort && sortSelect) {
    sortSelect.value = sort;
  }

  if (sortSelect) {
    sortSelect.addEventListener("change", (e) => {
      const selectedValue = e.target.value;
      const selectedLabel = e.target.options[e.target.selectedIndex].text;
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set("sort_by", selectedValue);

      const newUrl = new URL(window.location.href);
      newUrl.search = urlParams.toString();
    announceSortChange(selectedLabel);
      applyFilters(newUrl.href, container);

      // adapt url for history
      window.history.pushState({ path: newUrl.href }, "", newUrl.href);
    });
  }

  // get all filters from URL params if exists
  const filters = urlParams.getAll(ALL_VALID_FILTERS.join(","));

  ALL_VALID_FILTERS.forEach((filter) => {
    const filterValue = urlParams.get(filter);
    if (filterValue) {
      const filterSelect = collectionPage.querySelector(
        `select[name="${filter}"]`
      );
      if (filterSelect) {
        filterSelect.value = filterValue;
      }
      const filterCheckboxes = collectionPage.querySelectorAll(
        `input[name="${filter}"]`
      );
      filterCheckboxes.forEach((checkbox) => {
        if (checkbox.value === filterValue) {
          checkbox.checked = true;
        }
      });
      const filterInput = collectionPage.querySelector(
        `input[name="${filter}"]`
      );
      if (filterInput) {
        filterInput.value = filterValue;
      }
    }
  });
};
function announceSortChange(label) {
  let liveRegion = document.getElementById("sort-live-region");
  if (!liveRegion) {
    liveRegion = document.createElement("div");
    liveRegion.id = "sort-live-region";
    liveRegion.setAttribute("aria-live", "polite");
    liveRegion.setAttribute("role", "status");
    liveRegion.style.position = "absolute";
    liveRegion.style.width = "1px";
    liveRegion.style.height = "1px";
    liveRegion.style.overflow = "hidden";
    liveRegion.style.clip = "rect(0 0 0 0)";
    document.body.appendChild(liveRegion);
  }
  liveRegion.textContent = "Sorted by " + label;
}
function applyFilters(url, container) {
  const grid = container.querySelector(".MainCollection--grid");
  fetch(url)
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newContent = doc.querySelector(`.MainCollection--grid`);
      const newAmountShown = doc.querySelector(`.CollectionCount`);
      grid.replaceWith(newContent);

      // Adjust other elements as needed
      document.querySelector(".CollectionCount").textContent =
        newAmountShown.textContent;

      publish(PUB_SUB_EVENTS.contentAdded, { content: newContent });
    })
    .catch((error) => console.error("Error fetching new content:", error));
}

initCollectionFilters();

const collectionGrid = document.querySelector(".MainCollection--grid");
let collectionQueueSleeping = false;
const readySectionsQueue = [];

const initCollectionPage = (page) => {
  const nextPageTrigger = page.querySelector(
    ".CollectionGrid--next-page-trigger"
  );

  if (!nextPageTrigger) return;
  
  let loading = false;

  if (!nextPageTrigger.dataset.nextPage) {
    nextPageTrigger.remove();
    return;
  }

  window.addEventListener("scroll", async (e) => {
    // check if the next page trigger is close to the bottom of the viewport
    const rect = nextPageTrigger.getBoundingClientRect();
    const isClose = rect.bottom <= window.innerHeight * 1.5;

    if (isClose && !loading) {
      loading = true;
      await registerNextPage();
    }
  });

  async function registerNextPage() {
    const next = await getCollectionPageData(nextPageTrigger.dataset.nextPage);
    readySectionsQueue.push(next);
    // remove the old next page trigger
    nextPageTrigger.remove();
    collectionQueueSleeping = false;
  }
};

if (collectionGrid) {
  initCollectionPage(collectionGrid.querySelector(".CollectionGrid--page"));
  treatCollectionQueue();
}

function treatCollectionQueue() {
  if (collectionQueueSleeping) {
    setTimeout(() => {
      treatCollectionQueue();
    }, 10);
    return;
  }

  while (readySectionsQueue.length > 0) {
    const section = readySectionsQueue.shift();
    if (section) {
      const newProducts = section.querySelectorAll(".CollectionGrid--product");
      const page = collectionGrid.querySelector(".CollectionGrid--page");

      if (page) {
        newProducts.forEach((product) => {
          page.appendChild(product);
          publish(PUB_SUB_EVENTS.contentAdded, { content: product });
        });
        page.appendChild(
          section.querySelector(".CollectionGrid--next-page-trigger")
        );
        publish(PUB_SUB_EVENTS.contentAdded, { content: page });
      }
    }
  }
  collectionQueueSleeping = true;
  setTimeout(() => {
    treatCollectionQueue();
  }, 10);
}

subscribe(PUB_SUB_EVENTS.contentAdded, function (data) {
  const page = data.content.matches(".CollectionGrid--page")
    ? data.content
    : data.content.querySelector(".CollectionGrid--page");

  if (page) initCollectionPage(page);
});

async function getCollectionPageData(url) {
  return await fetch(url)
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const collectionPage = doc.querySelector(".CollectionGrid--page");
      return collectionPage;
    });
}

function initCollectionTypes() {
  const types = document.querySelectorAll(".CollectionsGrid--type");

  types.forEach((type) => {
    const url = type.querySelector(".CollectionsGrid--type-btn a").href;
    const grid = type.querySelector(".CollectionsGrid--products");
    const numberField = type.querySelector(".CollectionsGrid--type-header sup");

    const res = fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        // get grid products
        const products = doc.querySelectorAll(
          ".MainCollection--grid .CollectionGrid--product:not(.CollectionGrid--image-card):not(.CollectionGrid--info-card)"
        );

        const totalNumber = doc.querySelector(".CollectionCount").textContent;
        numberField.textContent = `(${totalNumber})`;

        // add products to the grid if it has under 4 products until it gets to 4
        if (grid.children.length < 4) {
          const productsToAdd = 4 - grid.children.length;
          const existingProductIds = new Set(
            Array.from(grid.children).map(
              (child) =>
                child.querySelector(".ProductThumbnail").dataset.productId
            )
          );

          for (let i = 0; i < productsToAdd; i++) {
            const product = products[i];
            if (
              product &&
              !existingProductIds.has(
                product.querySelector(".ProductThumbnail").dataset.productId
              )
            ) {
              grid.appendChild(product);
              publish(PUB_SUB_EVENTS.contentAdded, { content: product });
              existingProductIds.add(product.dataset.productId);
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching new content:", error);
      });
  });
}
initCollectionTypes();
